// extracted by mini-css-extract-plugin
module.exports = {"frag":"Tab4_frag__aEGHv"};